"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorIcons = exports.getTemplateIcon = void 0;
const template_icons_1 = require("template-icons");
const icons_1 = __importDefault(require("../templates/icons"));
exports.getTemplateIcon = (iconUrl, environment) => {
    const UserIcon = iconUrl && template_icons_1.ColorIcons[iconUrl] ? template_icons_1.ColorIcons[iconUrl] : icons_1.default(environment);
    const OfficialIcon = icons_1.default(environment);
    return {
        UserIcon,
        OfficialIcon,
    };
};
exports.ColorIcons = template_icons_1.ColorIcons;
